import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { checkFatca } from '../../redux-store/actions/newPurchase';
import { RootStateType } from '../../redux-store/reducers';
import { isFatcaVerified } from '../dashboard/commercial/utils';
import { FatcaCheckProps } from './FatcaCheck.types';
import enUs from '../../lang/en-us';
import { IsAllow } from '../../redux-store/types/portfolio';

const { dbCommercial } = enUs;

function FatcaCheck({
    rtaName,
    checkFatca,
    cancelCallBack = null,
    callApi = true,
    showDialog = true,
}: FatcaCheckProps) {
    const history = useHistory();
    const { fatcaStatusData } = useSelector(({ newPurchase }: RootStateType) => ({
        fatcaStatusData: newPurchase.fatcaStatusData,
    }));
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        async function checkForFatca() {
            try {
                setLoading(true);
                await checkFatca();
            } catch (err: any) {
                alert(err.message);
                history.goBack();
            } finally {
                setLoading(false);
            }
        }
        let shouldCallApi =
            !fatcaStatusData ||
            fatcaStatusData[0]?.fhFatcaStatus !== IsAllow.YES ||
            fatcaStatusData[1]?.fhFatcaStatus !== IsAllow.YES;
        if (shouldCallApi && callApi) {
            checkForFatca();
        }
    }, []);
    useEffect(() => {
        if (!!fatcaStatusData) {
            setError(!isFatcaVerified(fatcaStatusData, rtaName));
        }
    }, [fatcaStatusData, showDialog]);
    const handleCancel = () => {
        if (!!cancelCallBack) {
            cancelCallBack(setError);
        } else {
            history.goBack();
        }
    };
    return (
        <>
            <Dialog maxWidth={'sm'} open={loading} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p>{dbCommercial.fatcaStatus.checking}</p>
                </div>
            </Dialog>
            <Dialog maxWidth={'sm'} open={error && showDialog} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>{dbCommercial.fatcaStatus.heading}</h3>
                    <div>
                        <p style={{ marginBottom: 15 }}>{dbCommercial.fatcaStatus.info1}</p>
                        <p style={{ marginBottom: 15 }}>{dbCommercial.fatcaStatus.info2}</p>
                        <p style={{ marginBottom: 40 }}>{dbCommercial.fatcaStatus.info3}</p>
                    </div>
                    <div className="note-modals-btns">
                        <Button className="customBtn cancelBtn" onClick={handleCancel}>
                            {dbCommercial.fatcaStatus.cancel}
                        </Button>
                        <Button
                            className="customBtn"
                            onClick={() => history.replace('/portal/nct/fatca-declaration')}
                        >
                            {dbCommercial.fatcaStatus.continue}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
export default connect(null, { checkFatca })(FatcaCheck);
